export default __webpack_public_path__ + "assembly12a9dc9f.png";